import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from 'axios';
import {
    ISimulatorCalculateSimulationOptions,
    ISimulatorService,
    ISimulatorServiceRequest,
    ISimulatorServiceResponse
} from "./PA.Simulator.Services.IF";

export class SimulatorService
    implements ISimulatorService
{
    CalculateAndSaveSimulation(wbScenarioId: number, options?: ISimulatorCalculateSimulationOptions): Promise<ISimulatorServiceResponse> {
        let aCalculateRequest: ISimulatorServiceRequest = {
            RequestType: "CalculateAndSave",
            RequestOptions: options || {},
            wbSimulationId: wbScenarioId
        };

        return this.makeRequest(aCalculateRequest)
    }

    private makeRequest(aRequest: ISimulatorServiceRequest): Promise<ISimulatorServiceResponse> {
        return new Promise<ISimulatorServiceResponse>((resolve, error) => {
            let sEndPoint = <string>PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/");
            if (sEndPoint.endsWith('/')) {
                sEndPoint += 'simulatorService';
            } else {
                sEndPoint += '/simulatorService';
            }

            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp: any) => {
                    let responseData = resp.data;
                    resolve(responseData);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

}